import ArticleThreads from "./article-threads.vue";

window.Vue.createApp({
    components: {
        ArticleThreads,
    },
}).mount("#threads-section");
